module.exports = __webpack_public_path__ + "img/T1C_rc_14.009ef866.png";